module.exports = __webpack_public_path__ + "static/media/colisactivWhite.9d60f169.png";